var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{attrs:{"id":"jump-to-header"}},[_vm._v(_vm._s(_vm.heading || "Update"))]),_c('poly-integer-reference-update',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }